import { ManageSubscription } from "features/subscriptions/components";
import type { PRICING_PLANS } from "features/subscriptions/constants";
import useManageSubscriptionSteps from "features/subscriptions/hooks/useManageSubscriptionSteps";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface ManageSubscriptionDialogProps {
  plan: keyof typeof PRICING_PLANS;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function ManageSubscriptionDialog({
  isOpen,
  setIsOpen,
  plan,
}: ManageSubscriptionDialogProps) {
  const isDesktop = useTwBreakpoint("lg");
  const {
    manageSubscriptionStep,
    goToManageSubscriptionStep,
    resetManageSubscriptionStep,
    dialogSize,
  } = useManageSubscriptionSteps(plan);

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={resetManageSubscriptionStep}
    >
      <Content size={dialogSize}>
        <ManageSubscription
          plan={plan}
          step={manageSubscriptionStep}
          goToStep={goToManageSubscriptionStep}
        />
      </Content>
    </Component>
  );
}
